import { Modal } from 'antd';
import { logEvent } from '../../analytics';
import deleteSession from '../../utils/session/deleteSession';

export default async function confirmVisitDiscard({ 
  sessionUuid, 
  t 
}) {
  return new Promise((resolve) => {
    Modal.confirm({
      title: t('note_type_selector.confirm_title'),
      content: t('note_type_selector.confirm_context'),
      okText: t('note_type_selector.confirm_ok_text'),
      okType: 'danger',
      cancelText: t('note_type_selector.confirm_no_text'),
      onOk: async () => {
        try {
          const success = await deleteSession(sessionUuid);
          logEvent('SessionRecorder', 'DiscardConfirm');
          resolve(success);
        } catch (err) {
          console.error('Error during session discard:', err);
          resolve(false);
        }
      },
      onCancel: () => resolve(false),
    });
  });
} 